import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-hs-property-inspections.component.scss';

export class FormItemHsPropertyInspections extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	buyOwnSelect: HTMLFormElement[];
	maintainSellSelect: HTMLFormElement[];
	insuredByStandardBankSelect: HTMLFormElement[];
	requestInsuranceQuoteSelect: HTMLFormElement[];
	awarenessAboutServiceSelect: HTMLFormElement;
	awarenessAboutServiceDetailsInput: HTMLFormElement;
	initialsInput: HTMLFormElement;

	_buyOwnSelectValue: string;
	_maintainSellSelectValue: string;
	_insuredByStandardBankSelectValue: string;
	_requestInsuranceQuoteSelectValue: string;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-hs-property-inspections__button');

		this.buyOwnSelect =  Array.from(this.element.querySelectorAll("input[name=buying-own]"));
		this.maintainSellSelect = Array.from(this.element.querySelectorAll("input[name=maintain-sell]"));
		this.insuredByStandardBankSelect = Array.from(this.element.querySelectorAll("input[name=insured-by-standardbank]"));
		this.requestInsuranceQuoteSelect = Array.from(this.element.querySelectorAll("input[name=request-insurance-quote]"));
		this.awarenessAboutServiceSelect = this.element.querySelector('select[name=awareness-about-service]');
		this.awarenessAboutServiceDetailsInput = this.element.querySelector('input[name=awareness-about-service-details]');
		this.initialsInput = this.element.querySelector('input[name=initials]');

		this.initialsInput.setAttribute("maxLength", "3");

		this._buyOwnSelectValue = "BUYING";
		this._maintainSellSelectValue = "MAINTAIN";
		this._insuredByStandardBankSelectValue = "YES";
		this._requestInsuranceQuoteSelectValue = "YES";

		if (this.buyOwnSelect) {
			this.updateFormBuyOwn(this._buyOwnSelectValue);
		}

		if (this.awarenessAboutServiceSelect) {
			this.updateFormAwarenessAboutService(this.awarenessAboutServiceSelect.value);
		}
	}

	bindEvents() {

		this.submitBtn.addEventListener('click', (event) => {
			const _button = event.target as HTMLFormElement;
			const _form = _button.closest('form') as HTMLFormElement;
			const formFields: any = _form.querySelectorAll('input, select');
			this.validationService.validate(formFields);
			const valid = Array.from(_form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.submitForm(_form);
			}
		});

		if (this.buyOwnSelect) {
			this.buyOwnSelect.map(_radio => {
				_radio.addEventListener('change', (event: any) => {
					this._buyOwnSelectValue = _radio.value;
					this.updateFormBuyOwn(this._buyOwnSelectValue);
				});
			});
		}

		if (this.maintainSellSelect) {
			this.maintainSellSelect.map(_radio => {
				_radio.addEventListener('change', (event: any) => {
					this._maintainSellSelectValue = _radio.value;
				});
			});
		}

		if (this.insuredByStandardBankSelect) {
			this.insuredByStandardBankSelect.map(_radio => {
				_radio.addEventListener('change', (event: any) => {
					this._insuredByStandardBankSelectValue = _radio.value;
					this.updateFormInsure();
				});
			});
		}

		if (this.requestInsuranceQuoteSelect) {
			this.requestInsuranceQuoteSelect.map(_radio => {
				_radio.addEventListener('change', (event: any) => {
					this._requestInsuranceQuoteSelectValue = _radio.value;
				});
			});
		}

		if (this.awarenessAboutServiceSelect) {
			this.awarenessAboutServiceSelect.addEventListener('change', (event) => {
				this.updateFormAwarenessAboutService(this.awarenessAboutServiceSelect.value);
			});
		}
	}

	updateFormBuyOwn(type) {

		if (this.maintainSellSelect && this.insuredByStandardBankSelect) {
			const _maintainSellGroup = this.maintainSellSelect[0].closest(".form__group");
			const _insuredByStandardBankGroup = this.insuredByStandardBankSelect[0].closest(".form__group");

			if (type !== 'OWN') {

				_maintainSellGroup.classList.add('form__group--hidden');
				_insuredByStandardBankGroup.classList.add('form__group--hidden');
			} else {

				_maintainSellGroup.classList.remove('form__group--hidden');
				_insuredByStandardBankGroup.classList.remove('form__group--hidden');
			}

			this.updateFormInsure();
		}

	}

	updateFormInsure() {

		if (this.buyOwnSelect && this.insuredByStandardBankSelect && this.requestInsuranceQuoteSelect ) {
			const _requestInsuranceQuoteGroup = this.requestInsuranceQuoteSelect[0].closest(".form__group");
			if (this._buyOwnSelectValue === 'BUYING') {
				_requestInsuranceQuoteGroup.classList.remove('form__group--hidden');
			}
			else if (this._buyOwnSelectValue === 'OWN' && this._insuredByStandardBankSelectValue === 'NO') {
				_requestInsuranceQuoteGroup.classList.remove('form__group--hidden');
			}
			else {
				_requestInsuranceQuoteGroup.classList.add('form__group--hidden');
			}
		}
	}

	updateFormAwarenessAboutService(type) {

		if (this.awarenessAboutServiceDetailsInput) {
			const _awarenessAboutServiceDetailsGroup = this.awarenessAboutServiceDetailsInput.closest(".form__group");
			if (type !== 'OTHER') {
				this.awarenessAboutServiceDetailsInput.classList.remove("form__input--required");
				_awarenessAboutServiceDetailsGroup.classList.add('form__group--hidden');

			} else {

				_awarenessAboutServiceDetailsGroup.classList.remove('form__group--hidden');
				this.awarenessAboutServiceDetailsInput.classList.add("form__input--required");
			}
		}

	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		let postData = '';

		let serviceType: any = form.querySelector("input[name=serviceType]");
		if (serviceType) {
			postData += 'service-type=' + serviceType.value;
		}
		let product: any = form.querySelector("input[name=product]");
		if (product) {
			postData += '&product=' + product.value;
		}
		let description: any = form.querySelector("input[name=description]");
		if (description) {
			postData += '&description=' + description.value;
		}
		let email: any = form.querySelector("input[name=email]");
		if (email) {
			postData += '&email=' + email.value;
		}
		let recipient: any = form.querySelector("input[name=recipient]");
		if (recipient) {
			postData += '&recipient=' + recipient.value;
		}
		let subject: any = form.querySelector("input[name=subject]");
		if (subject) {
			postData += '&subject=' + subject.value;
		}
		let redirect: any = form.querySelector("input[name=redirect]");
		if (redirect) {
			postData += '&redirect=' + redirect.value;
		}
		let _title: any = this.form.querySelector('select[name=name-title]');
		if (_title) {
			postData += '&title=' + _title.value;
		}
		let _initials: any = this.form.querySelector('input[name=initials]');
		if (_initials) {
			postData += '&initials=' + _initials.value.toUpperCase();
		}
		let _firstName: any = this.form.querySelector('input[name=first-name]');
		if (_firstName) {
			postData += '&firstname=' + _firstName.value;
		}
		let _surname: any = this.form.querySelector('input[name=last-name]');
		if (_surname) {
			postData += '&surname=' + _surname.value;
		}
		let _contact: any = this.form.querySelector('input[name=contact-number]');
		if (_contact) {
			postData += '&contact=' + _contact.value;
		}
		let _email: any = this.form.querySelector('input[name=email-address]');
		if (_email) {
			postData += '&emailAddress=' + _email.value;
		}
		let _residentialAddress: any = this.form.querySelector('input[name=residential-address]');
		if (_residentialAddress) {
			postData += '&residentialAddress=' + _residentialAddress.value;
		}
		let _suburb: any = this.form.querySelector('input[name=suburb]');
		if (_suburb) {
			postData += '&suburb=' + _suburb.value;
		}
		let _city: any = this.form.querySelector('input[name=city]');
		if (_city) {
			postData += '&city=' + _city.value;
		}
		let _areaCode: any = this.form.querySelector('input[name=areaCode]');
		if (_areaCode) {
			postData += '&areaCode=' + _areaCode.value;
		}
		let _buyingOwn: any = this._buyOwnSelectValue;
		if (_buyingOwn) {
			postData += '&buyingOwn=' + _buyingOwn;
		}
		let _maintainSell: any = this._maintainSellSelectValue
		if (_maintainSell) {
			if (_buyingOwn !== 'OWN') {
				postData += '&maintainSell=';
			} else {
				postData += '&maintainSell=' + _maintainSell;
			}
		}
		else {
			postData += '&maintainSell=';
		}
		let _insuredByStandardBank: any = this._insuredByStandardBankSelectValue;
		if (_insuredByStandardBank) {
			if (_buyingOwn !== 'OWN') {
				postData += '&insuredByStandardBank=';
			} else {
				postData += '&insuredByStandardBank=' + _insuredByStandardBank;
			}
		}
		else {
			postData += '&insuredByStandardBank=';
		}
		let _requestInsuranceQuote: any = this._requestInsuranceQuoteSelectValue
		if (_requestInsuranceQuote) {
			if (_buyingOwn === 'BUYING') {
				postData += '&requestInsuranceQuote=' + _requestInsuranceQuote;
			} else if (_buyingOwn === 'OWN' && _insuredByStandardBank === 'NO') {
				postData += '&requestInsuranceQuote=' + _requestInsuranceQuote;
			} else {
				postData += '&requestInsuranceQuote=';
			}
		}
		else {
			postData += '&requestInsuranceQuote=';
		}
		let _awarenessAboutService: any = this.form.querySelector('select[name=awareness-about-service]');
		if (_awarenessAboutService) {
			postData += '&awarenessAboutService=' + _awarenessAboutService.value;
		}
		let _awarenessAboutServiceDetails: any = this.form.querySelector('input[name=awareness-about-service-details]');
		if (_awarenessAboutServiceDetails) {
			if (_awarenessAboutService.value !== 'OTHER') {
				postData += '&awarenessAboutServiceDetails=';
			} else {
				postData += '&awarenessAboutServiceDetails=' + _awarenessAboutServiceDetails.value;
			}
		}
		else {
			postData += '&awarenessAboutServiceDetails=';
		}

		// loader + hide form
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitGenericForm.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			loader.classList.remove('active');
			//Always show success message / no response from server (sending email)
			analyticsService.dtmFormComplete('complete', response.code);
			thankYou.classList.add('active');
			error.classList.remove('active');
			error.classList.add('hidden');
			success.classList.remove('hidden');
			success.classList.add('active');
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
		this.resetForm();
	}

	resetForm() {

		this._buyOwnSelectValue = "BUYING";
		this._maintainSellSelectValue = "MAINTAIN";
		this._insuredByStandardBankSelectValue = "YES";
		this._requestInsuranceQuoteSelectValue = "YES";

		this.updateFormBuyOwn(this._buyOwnSelectValue);
		this.updateFormInsure();

		const _awarenessAboutServiceDetailsGroup = this.awarenessAboutServiceDetailsInput.closest(".form__group");

		this.awarenessAboutServiceDetailsInput.classList.remove("form__input--required");
		_awarenessAboutServiceDetailsGroup.classList.add('form__group--hidden');
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-hs-property-inspections/form-item-hs-property-inspections.component.ts